import { BlockingObjTypes } from "../const/blockingObjTypes";
import { CreateBlockingTypes } from "../interfaces/Blocking";
import buildUrl from "../utils/buildUrl";
import { baseUrl } from "./baseUrl";

export const getBlockingCurrentStateRoute = (
  objectTypeId: BlockingObjTypes,
  objectId: number | string,
  onDate?: string
) =>
  buildUrl({
    url: `${baseUrl}/blocking-manager-api/blocking/${objectTypeId}/${objectId}/status`,
    searchParams: {
      onDate,
    },
  });

export const getBlockingCurrentStateVersionsRoute = (
  objectTypeId: BlockingObjTypes,
  objectId: number | string,
  onDate?: string
) =>
  buildUrl({
    url: `${baseUrl}/blocking-manager-api/blocking/${objectTypeId}/${objectId}/status/versions`,
    searchParams: {
      onDate,
    },
  });

export const getBlockingRequestSearchRoute = (
  objectTypeId: number,
  objectId: number | string,
  includeFutureDates: boolean,
  includePastDates: boolean
) =>
  buildUrl({
    url: `${baseUrl}/blocking-manager-api/blocking/request/search`,
    searchParams: {
      objectId,
      objectTypeId,
      includeFutureDates,
      includePastDates,
    },
  });

export const getBlockingTypesRoute = (params?: { onDate?: string }) =>
  buildUrl({
    url: `${baseUrl}/blocking-manager-api/blocking-types/search`,
    searchParams: {
      ...params,
    },
  });

export const getBlockingTypesVersionsRoute = (blockingTypeId: number) =>
  buildUrl({
    url: `${baseUrl}/blocking-manager-api/blocking-types/${blockingTypeId}/versions`,
    searchParams: {
      blockingTypeId,
    },
  });

export const postBlockingTypesRoute = () =>
  buildUrl({
    url: `${baseUrl}/blocking-manager-api/blocking-types`,
  });

export const deleteBlockingTypesRoute = (blockingTypeId, fromDate) =>
  buildUrl({
    url: `${baseUrl}/blocking-manager-api/blocking-types/${blockingTypeId}`,
    searchParams: {
      fromDate,
    },
  });

export const updateBlockingTypesRoute = (blockingTypeId, fromDate) =>
  buildUrl({
    url: `${baseUrl}/blocking-manager-api/blocking-types`,
    searchParams: {
      blockingTypeId,
      fromDate,
    },
  });

export const postBlockingRequestRoute = (objectTypeId, objectId) =>
  buildUrl({
    url: `${baseUrl}/credit-control-api/blocking/${objectTypeId}/${objectId}/activate`,
  });

export const deactivateBlockingRequestRoute = (requestId) =>
  buildUrl({
    url: `${baseUrl}/credit-control-api/blocking/${requestId}/deactivate`,
  });

export const checkDeactivationBlockingRequestRoute = (requestId, onDate) =>
  buildUrl({
    url: `${baseUrl}/credit-control-api/blocking/${requestId}/deactivate/check`,
    searchParams: {
      onDate,
    },
  });

export const editDateBlockingRequestRoute = (requestId, fromDate) =>
  buildUrl({
    url: `${baseUrl}/blocking-manager-api/blocking/request/${requestId}`,
    searchParams: {
      fromDate,
    },
  });

export const createReasonForBlockingRequestRoute = () =>
  buildUrl({
    url: `${baseUrl}/dict-api/reason`,
  });
